// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__R-9b7","text":"SelectPayment_text__3M_3E","title":"SelectPayment_title__2Ojbo","btn":"SelectPayment_btn__3Rq1h"};